var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"space-around","align":"center"}},[_c('v-time-picker',{attrs:{"scrollable":""},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }